import { Routes, Route, Navigate } from 'react-router-dom'
import HomePage from './pages/HomePage'
import Login from './pages/Login'
import Register from './pages/Register'
import VerifyEmail from './pages/VerifyEmail'
import ForgotPassword from './pages/ForgotPassword'
import Portal from './pages/portal'
import HomeTab from './pages/portal/tabs/HomeTab'
import TasksTab from './pages/portal/tabs/TasksTab'
import TaskDetailView from './pages/portal/tabs/TaskDetailView'
import ApplicationsTab from './pages/portal/tabs/ApplicationsTab'
import ApplicationView from './pages/portal/tabs/ApplicationView'
import ApplicationMessagesTab from './pages/portal/tabs/ApplicationMessagesTab'
import MyAccountTab from './pages/portal/tabs/MyAccountTab'
import CreateApplication from './pages/portal/tabs/CreateApplication'
import NotFound from './pages/portal/tabs/NotFound'
import AgencyLogin from './pages/partner/AgencyLogin'
import AgencyRegister from './pages/partner/AgencyRegister'
import AgencyForgotPassword from './pages/partner/AgencyForgotPassword'
import AgencyPortal from './pages/partner/portal'
import AgencyHomeTab from './pages/partner/portal/AgencyHomeTab'
import AgencyStudentsTab from './pages/partner/portal/AgencyStudentsTab'
import AgencyStudentDetailView from './pages/partner/portal/AgencyStudentDetailView'
import AgencyApplicationsTab from './pages/partner/portal/AgencyApplicationsTab'
import AgencyApplicationView from './pages/partner/portal/AgencyApplicationView'
import AgencyAccountTab from './pages/partner/portal/AgencyAccountTab'
import AgencyApplicationFormPage from './pages/partner/portal/AgencyApplicationFormPage'
import AgencyApplicantCreatePage from './pages/partner/portal/AgencyApplicantCreatePage'
import { BrandingProvider } from './context/BrandingContext'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AgencyProtectedRoute } from './components/AgencyProtectedRoute'

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <div className="min-h-screen">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/partner/agency-login" element={<AgencyLogin />} />
            <Route path="/partner/agency-register" element={<AgencyRegister />} />
            <Route path="/partner/forgot-password" element={<AgencyForgotPassword />} />
            <Route
              path="/partner"
              element={
                <AgencyProtectedRoute>
                  <AgencyPortal />
                </AgencyProtectedRoute>
              }
            >
              <Route index element={<Navigate to="home" replace />} />
              <Route path="home" element={<AgencyHomeTab />} />
              <Route path="tasks" element={<TasksTab basePath="/partner" conversationPath="applications" />} />
              <Route path="tasks/:taskId" element={<TaskDetailView basePath="/partner" />} />
              <Route path="students" element={<AgencyStudentsTab />} />
              <Route path="students/:memberId" element={<AgencyStudentDetailView />} />
              <Route path="applicant/create" element={<AgencyApplicantCreatePage />} />
              <Route path="students/:memberId/create-application" element={<AgencyApplicationFormPage />} />
              <Route path="applications" element={<AgencyApplicationsTab />} />
              <Route path="applications/:applicationNumber" element={<AgencyApplicationView />} />
              <Route path="applications/:applicationNumber/messages" element={<AgencyApplicationView />} />
              <Route path="account" element={<AgencyAccountTab />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <Portal />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="home" replace />} />
              <Route path="home" element={<HomeTab />} />
              <Route path="tasks" element={<TasksTab />} />
              <Route path="tasks/:taskId" element={<TaskDetailView />} />
              <Route path="applications" element={<ApplicationsTab />} />
              <Route path="applications/:applicationNumber" element={<ApplicationView />} />
              <Route path="applications/:applicationNumber/messages" element={<ApplicationMessagesTab />} />
              <Route path="create-application" element={<CreateApplication />} />
              <Route path="account" element={<MyAccountTab />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </div>
      </BrandingProvider>
    </AuthProvider>
  )
}

export default App
